<template>
  <b-row>
    <div class="col-md-6">
      <card class="stacked-form">
        <form v-on:submit.prevent="doSubmit">
          <div>
            
            <b-col md="12">
                <label for="">Role</label>
                <el-select size="large" clearable v-model="model.role_id" placeholder="Role">
                    <el-option v-for="role in roleList" :value="role.value" :label="role.label" :key="role.id">
                    </el-option>
                </el-select>
            </b-col>
            <b-col md="12">
                <b-form-group label="Permission">
                    <b-form-checkbox-group
                        id="checkbox-group-1"
                        v-model="model.permission"
                        :options="permissionList"
                        name="flavour-1"
                    ></b-form-checkbox-group>
                </b-form-group>
            </b-col>
            <save-data-button :disabled="saveButtonData.isLoading" :is-create="$route.params.id === undefined" :state="saveButtonData.isLoading && saveButtonData.state === 1 ? 2 : saveButtonData.state" :is-loading="saveButtonData.isLoading"/>
            <cancel-button/>
          </div>
        </form>
      </card>
    </div>
  </b-row>
</template>
<script>
  import { DatePicker, Select, Option, Switch } from 'element-ui'
  import { Radio } from '@/components/index'
  import SaveData from '@/components/Buttons/SaveData'
  import Cancel from '@/components/Buttons/Cancel'

  export default {
    components: {
      SaveDataButton: SaveData,
      CancelButton: Cancel,
      [Option.name]: Option,
      [Select.name]: Select,
      [DatePicker.name]: DatePicker,
      LRadio: Radio,
      LSwitch: Switch
    },
    data () {
      return {
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        apiUrl: {
          profile: window.AppConfig.apiUrl + 'profile',
          role: window.AppConfig.apiUrl + 'role',
          permission: window.AppConfig.apiUrl + 'permission'
        },
        model: {
          role_id: '',
          permission: []
        },
        roleList: [],
        permissionList: []
      }
    },
    watch: {
      '$route.params.id': function (val) {
        this.initData()
      }
    },
    mounted () {
      this.initData()
      this.getRole()
      this.getPermission()
    },
    methods: {
      initData () {
        if (this.$route.params.id !== undefined) {
          this.getDetail()
        }
        setTimeout(() => {
          document.getElementsByName('name')[0].focus()
        }, 100)
      },
      getRole () {
        this.$http.get(this.apiUrl.role)
        .then(resp => {
          resp.data.data.forEach(data => {
            this.roleList.push({
              label: data.name,
              value: data.id
            })
          })
        })
      },
      getPermission () {
        this.$http.get(this.apiUrl.permission + '?limit=500')
        .then(resp => {
          resp.data.data.forEach(data => {
            this.permissionList.push({
              text: data.name,
              value: data.id
            })
          })
        })
      },
      getDetail () {
        this.saveButtonData.isLoading = true
        this.saveButtonData.state = 3
        this.$http.get(this.apiUrl.profile + '/' + this.$route.params.id)
        .then(response => {
          this.model.name = response.data.name
          this.model.email = response.data.email
          this.saveButtonData.isLoading = false
          this.saveButtonData.state = 1
        })
        .catch(error => {
          this.saveButtonData.isLoading = false
          this.saveButtonData.state = 1
          this.$store.dispatch('notification/error', error)
          this.$router.push('/notfound')
        })
      },
      doSubmit () {
        this.$http.post(this.apiUrl.permission, this.model).then(response => {
          this.saveButtonData.isLoading = false
          this.model.role = null
          this.$store.dispatch('notification/success', 'Permission has been added.')
        }).catch(error => {
          this.saveButtonData.isLoading = false
          this.$store.dispatch('notification/error', error)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Settings/Permission/Form.vue